var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-columns-menu"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "max-width": "320",
      "min-width": "280"
    },
    on: {
      "input": _vm.onMenuToggle
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var tooltipOn = _ref2.on,
                tooltipAttrs = _ref2.attrs;
              return [_c('button', _vm._g(_vm._b({
                staticClass: "table-toolbar__action",
                "class": {
                  'table-toolbar__action--active': _vm.menuOpen
                },
                attrs: {
                  "type": "button",
                  "aria-label": _vm.$translate('manageColumns')
                }
              }, 'button', Object.assign({}, attrs, tooltipAttrs), false), Object.assign({}, on, tooltipOn)), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-view-column-outline")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.$translate("manageColumns")))])])];
      }
    }]),
    model: {
      value: _vm.menuOpen,
      callback: function callback($$v) {
        _vm.menuOpen = $$v;
      },
      expression: "menuOpen"
    }
  }, [_c('v-card', {
    staticClass: "table-columns-menu__panel"
  }, [_c('div', {
    staticClass: "table-columns-menu__section-title px-4 pt-3 pb-1 text-caption grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("displayed")) + " ")]), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "handle": ".table-columns-menu__drag-handle",
      "filter": ".table-columns-menu__item--locked",
      "prevent-on-filter": true,
      "animation": 150,
      "ghost-class": "table-columns-menu__item--ghost",
      "chosen-class": "table-columns-menu__item--chosen",
      "drag-class": "table-columns-menu__item--drag",
      "move": _vm.onColumnMove
    },
    on: {
      "end": _vm.onDragEnd
    },
    model: {
      value: _vm.localVisibleColumns,
      callback: function callback($$v) {
        _vm.localVisibleColumns = $$v;
      },
      expression: "localVisibleColumns"
    }
  }, _vm._l(_vm.localVisibleColumns, function (col) {
    return _c('v-list-item', {
      key: 'vis-' + col.key,
      staticClass: "table-columns-menu__item",
      "class": {
        'table-columns-menu__item--locked': col.locked
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-2 my-0 align-self-center"
    }, [col.locked ? _c('v-icon', {
      attrs: {
        "small": "",
        "color": "grey"
      }
    }, [_vm._v(" mdi-lock-outline ")]) : _c('v-icon', {
      staticClass: "table-columns-menu__drag-handle",
      attrs: {
        "small": ""
      }
    }, [_vm._v(" mdi-drag ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(col.label))])], 1), !col.locked ? _c('v-list-item-action', {
      staticClass: "ma-0"
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "x-small": "",
        "aria-label": _vm.$translate('hideColumn')
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.hideColumn(col.key);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-eye-off-outline")])], 1)], 1) : _vm._e()], 1);
  }), 1)], 1), _vm.hiddenColumns.length ? [_c('v-divider', {
    staticClass: "my-2"
  }), _c('div', {
    staticClass: "table-columns-menu__section-title px-4 pb-1 text-caption grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("hidden")) + " ")]), _c('v-list', {
    staticClass: "py-0 pb-2",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.hiddenColumns, function (col) {
    return _c('v-list-item', {
      key: 'hid-' + col.key,
      on: {
        "click": function click($event) {
          return _vm.showColumn(col.key);
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(col.label))])], 1), _c('v-list-item-action', {
      staticClass: "ma-0"
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-eye-outline")])], 1)], 1);
  }), 1)] : _vm._e(), _c('v-divider'), _c('div', {
    staticClass: "pa-2"
  }, [_c('button', {
    staticClass: "table-columns-menu__reset link",
    attrs: {
      "type": "button",
      "disabled": !_vm.customized
    },
    on: {
      "click": _vm.resetColumns
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("resetColumns")) + " ")])])], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }